import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StarRatingComponent),
      multi: true
    }
  ]
})
export class StarRatingComponent implements ControlValueAccessor {
  @Input() maxRating: number;
  @Input() itemsCount: number;
  @Input() lstTags: any;
  @Input() value: number;

  @Output() valueChanged = new EventEmitter<number>();

  // Controlador del evento de cambio
  onRatingChange(event: any) {
    this.value = event.value;
    this.onChange(this.value);
    this.emitValue(this.value);
  }

  emitValue(value: any): void {
    this.valueChanged.emit(value);
  }

  onChange = (value: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
